import { baseClient } from 'builder/modules/apiClient'
import { InterviewQuestion } from 'builder/modules/interview/types'
import { requestPolling } from 'builder/views/Interview/utils/requestPolling'

const requestFollowUpQuestions = async (
  interviewId: number,
  mainQuestionId: number,
  abortControl: AbortController,
) => {
  const response = await baseClient.get<{
    main_question: InterviewQuestion
    follow_up_questions: InterviewQuestion[]
  }>(
    // eslint-disable-next-line max-len
    `/interview_prep/interviews/${interviewId}/questions/${mainQuestionId}/follow_up_questions`,
    { signal: abortControl.signal },
  )
  return response.data
}

interface Params {
  interviewId: number
  mainQuestionId: number
  questionId: number
  expectedFollowUpQuestionCount: number
}

export const pollingFollowUpQuestionRequest = async ({
  interviewId,
  mainQuestionId,
  expectedFollowUpQuestionCount,
}: Params) => {
  const followUpQuestion = await requestPolling({
    timeout: 20000,
    requestFunction: async (abortControl: AbortController) => {
      const response = await requestFollowUpQuestions(interviewId, mainQuestionId, abortControl)

      const followUpQuestion = response.follow_up_questions.sort((a, b) => a.id - b.id)

      return {
        polling:
          !response.main_question.conversation_end &&
          expectedFollowUpQuestionCount !== response.follow_up_questions.length,
        data: followUpQuestion[response.follow_up_questions.length - 1],
      }
    },
  })
  return followUpQuestion
}
